export const getFileMimeType = (file: File): string => {
    const ext = file.name.toLowerCase().split('.').pop()
    const mimeTypes: { [key: string]: string } = {
        // Images
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'heic': 'image/heic',        // iPhone's default format since iOS 11
        'heif': 'image/heif',        // High Efficiency Image Format
        'webp': 'image/webp',        // Common on Android
        'gif': 'image/gif',

        // Documents
        'pdf': 'application/pdf',
        'md': 'text/markdown',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

        // Generic fallback
        'bin': 'application/octet-stream'
    }
    return mimeTypes[ext || ''] || 'application/octet-stream'
}